/** One labelled bar of fix 6 ("accuracy ▬▬▬", "speed ▬▬"), like the model list the owner pointed at (06b). */

export function Meter({ label, value }: { label: string; value: number }) {
  const pct = Math.round(Math.max(0, Math.min(1, value)) * 100);
  return (
    <span className="model-meter" data-meter={label}>
      <span>{label}</span>
      <i role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
        <b style={{ width: `${pct}%` }} />
      </i>
    </span>
  );
}
